function stringifyAdminLogValue(value: unknown): string {
  if (value instanceof Error) return value.message;
  if (typeof value === "string") return value;
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

export function redactAdminLogValue(value: unknown): string {
  return stringifyAdminLogValue(value)
    .replace(/([a-z][a-z0-9+.-]*:\/\/)([^:/@\s]+):([^/@\s]+)@/gi, "$1<redacted>:<redacted>@")
    .replace(/\b(bearer)\s+[a-z0-9._~+/=-]+/gi, "$1 <redacted>")
    .replace(
      /\b([a-z0-9_]*(?:token|secret|password|passwd|pwd|api[_-]?key)[a-z0-9_]*)\s*[:=]\s*("[^"]*"|'[^']*'|[^\s,;]+)/gi,
      "$1=<redacted>",
    );
}
